import type { useToast } from 'braid-design-system';

type Toast = Parameters<ReturnType<typeof useToast>>[0];

export const createSuccessToast = (
  toastMessage: string,
  toastDescription?: string,
) => {
  const genericSuccessfulToast: Toast = {
    tone: 'positive',
    message: toastMessage,
    ...(toastDescription && { description: toastDescription }),
  };

  return genericSuccessfulToast;
};

export const createCriticalToast = (
  toastMessage: string,
  toastDescription?: string,
) => {
  const genericCriticalToast: Toast = {
    tone: 'critical',
    message: toastMessage,
    ...(toastDescription && { description: toastDescription }),
  };

  return genericCriticalToast;
};
